var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('time-line-item-text', {
    attrs: {
      "icon": _vm.icon
    },
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm.referencedLoading ? _c('v-skeleton-loader', {
          staticClass: "mb-1",
          attrs: {
            "type": "text"
          }
        }) : _vm.referencedEntity ? _c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.activityText)
          }
        }) : _c('m-no-content')];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }